import { call, takeEvery, put, all, putResolve } from 'redux-saga/effects'
import { loadingActions } from 'loankeeper-common/components/hocs/LazyLoading'

import { Reporting } from 'WebAPI'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'

import { checkReportsStatus, generatedReportsFetched } from './actions'
import { actionTypes } from './constants'
import { translateLKMessage, translateFrm } from './translate'
import { reportsView, generate } from 'src/store/reporting'

let cancell = 1
let saveReportID = null
let startDate = null
let lastIdent = null

function* checkReportStatus({ payload, meta }) {
  if (cancell === 2) {
    loadingActions.stop()
    return
  }

  try {
    // const {Data} = yield call(Reporting.reportsView, {
    //   action: 'status',
    //   Ident: payload.Data,
    // })

    //UPDATED API REQUEST sqlreport2_view_api
    const reportsViewResult = yield putResolve<any>(
      reportsView({
        action: 'status',
        Ident: payload.Data,
      }),
    )

    if (!reportsView.fulfilled.match(reportsViewResult)) {
      loadingActions.stop()
      return
    }

    const { payload: Data } = reportsViewResult as any

    if (!Data.ExpireNewTS || Data.ExpireNewTS === 0) {
      // eslint-disable-next-line no-throw-literal
      throw {
        Error: {
          Message: translateFrm('ERROR'),
        },
      }
    }

    if ([3, 4, 5].indexOf(Data.StatusID) === -1) {
      //@ts-ignore
      yield put(checkReportsStatus(payload, meta))
    }

    if (Data.StatusID === 3 || Data.StatusID === null) {
      loadingActions.stop()

      yield put(LKModalActions.openError(translateLKMessage('HINT_ERR_TITLE')))
    } else if (Data.StatusID === 5) {
      const errorResponse = yield call(Reporting.reportsView, {
        action: 'viewerror',
        JobID: payload.JobID,
        HashSum_JobID_: payload.HashSum_JobID_,
      })

      loadingActions.stop()

      yield put(LKModalActions.openError(errorResponse.Data))
    } else if (Data.StatusID === 4) {
      const generatedReportsResponse = yield call(Reporting.reportsView, {
        action: 'view',
        Ident: payload.Data,
      })

      //@ts-ignore
      const time = (new Date() - startDate) / 1000
      yield put(
        generatedReportsFetched(
          { data: generatedReportsResponse.Data, time, params: meta, ident: lastIdent },
          saveReportID,
        ),
      )
      loadingActions.stop()
    }
  } catch (error) {
    loadingActions.stop()

    yield put(LKModalActions.openError(error.Error && translateLKMessage(error.Error.Message || error.Error.Text)))
  }
}

function* getReports({ payload }) {
  cancell = 1
  saveReportID = payload.ReportID
  try {
    //@ts-ignore
    loadingActions.start({ showTimer: true })
    // const response = yield call(Reporting.generate, payload) // JobID - HashSum_JobID_
    //UPDATE API REQUEST sqlreport2_api action: generate
    const response = yield putResolve<any>(generate(payload))
    if (!generate.fulfilled.match(response)) {
      loadingActions.stop()
      return
    }
    startDate = new Date()
    lastIdent = response.payload
    //@ts-ignore
    yield put(checkReportsStatus({ Data: response.payload }, payload))
  } catch (error) {
    loadingActions.stop()
    yield put(LKModalActions.openError(error.Error && translateLKMessage(error.Error.Message || error.Error.Text)))
  }
}

const cancelReports = () => {
  cancell = 2
}

export default function* watchGetReports() {
  yield all([
    //@ts-ignore
    takeEvery(actionTypes.FETCH_REPORTS, getReports),
    //@ts-ignore
    takeEvery(actionTypes.CHECK_REPORTS_STATUS, checkReportStatus),
    takeEvery(actionTypes.CANCEL_CHECK, cancelReports),
    // takeEvery(actionTypes.GET_EXCEL_FILE, getSqlExcel),
  ])
}
